import React from 'react';
import { useListings } from '@/utils/context/ListingsContext';

const Location: React.FC = () => {
    const { listings, handleSearchSubmit } = useListings();
    const currentValue: string = listings.params.location ? listings.params.location.value : ( listings.params.state ? listings.params.state.value : '' );
    const bounds: string = listings.params.bounds ? listings.params.bounds.value : '';
    const [ locationValue, setLocationValue ] = React.useState( currentValue );

    const handleClick = ( e: React.MouseEvent<HTMLButtonElement> ) => {
        e.preventDefault();
        if ( listings.params.location ) {
            listings.params.location.value = locationValue;
        }
        const form = e.currentTarget.form;
        if ( form ) {
            handleSearchSubmit( { preventDefault: () => {}, currentTarget: form } as unknown as React.FormEvent<HTMLFormElement> );
        }
    };

    const handleChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
        setLocationValue(e.target.value);
    };

    return (
            <span className="mls-field-wrapper mls-field-location">
                <span className="mls-field-inner-wrapper full">
                    <label htmlFor="location">Location</label>
                    <span className="mls-field-location-inner-wrapper">
                        <input 
                            type="text" 
                            autoComplete="off" 
                            name="location" 
                            id="location" 
                            className="mls-field mls-location" 
                            placeholder="City & State, or Zipcode" 
                            value={ locationValue }
                            onChange={ handleChange } />
                        <button className="mls-location-btn" onClick={ handleClick }><span>Search</span></button>
                    </span>
                    <input type="hidden" name="bounds" id="bounds" className="mls-field" value={ bounds } />
                </span>
            </span>
    );
}
export default Location;
